import { generateLocalsOptionList } from "utils/searchFilter";
import RangeFilter from "./RangeFilter";
import useSearchFilter from "hooks/useSearchFilter";
import { ReactComponent as BedroomsFilterIcon } from "assets/icons/bedroom.svg";

const BedroomFilter = () => {
  const { bedroomMin, bedroomMax, setBedroomMin, setBedroomMax } =
    useSearchFilter();

  return (
    <RangeFilter
      id="bedrooms"
      placeholder="Camere da Letto"
      options={generateLocalsOptionList()}
      unit="Camere da Letto"
      paramMin="bedroomMin"
      paramMax="bedroomMax"
      minValue={bedroomMin}
      maxValue={bedroomMax}
      setMinValue={setBedroomMin}
      setMaxValue={setBedroomMax}
      Icon={BedroomsFilterIcon}
    />
  );
};

export default BedroomFilter;
